import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import styled, { withTheme } from "styled-components";
import Checkbox from "../../ui-library/Checkbox/Checkbox";
import LabelledInput from "../../ui-library/LabelledInput/LabelledInput";

const StyledCheckboxLabel = styled("div")`
  font-weight: 600;
  margin-left: 15px;
  cursor: pointer;
`;

const StyledCheckboxWrapper = styled("div")`
  display: flex;
  margin-bottom: 15px;
`;

const Favorite = (props) => {
  const {
    errorMessage,
    hasError,
    onChangeFavoriteName,
    onChangeIsFavorite,
    showCheckbox = true,
    defaultIsFavorite,
    onBlur,
    defaultFavoriteName,
  } = props;

  const { t } = useTranslation();

  const [isFavorite, setIsFavorite] = useState(false);
  const [favoriteName, setFavoriteName] = useState("");

  const onChanged = (inputValue) => {
    setFavoriteName(inputValue);

    onChangeFavoriteName(inputValue);
  };

  const onCheckboxChanged = () => {
    setIsFavorite((prevState) => !prevState);
  };

  useEffect(() => {
    if (onChangeIsFavorite) {
      onChangeIsFavorite(isFavorite);
    }
  }, [isFavorite, onChangeIsFavorite]);

  useEffect(() => {
    if (defaultIsFavorite) {
      setIsFavorite(defaultIsFavorite);
    }
  }, [defaultIsFavorite]);

  useEffect(() => {
    if (defaultFavoriteName) {
      setFavoriteName(defaultFavoriteName);
    }
  }, [defaultFavoriteName]);

  return (
    <div data-testid="is-favorite">
      {showCheckbox && (
        <StyledCheckboxWrapper>
          <Checkbox
            checked={isFavorite}
            onClick={() => onCheckboxChanged()}
            icon={true}
            square={true}
            className="favorite-checkbox"
          />
          <StyledCheckboxLabel onClick={() => onCheckboxChanged()}>
            {t("appText.dietDiary.addMeal.addFavorites")}
          </StyledCheckboxLabel>
        </StyledCheckboxWrapper>
      )}
      {isFavorite && (
        <div>
          <LabelledInput
            data-testid="favorite-name-input"
            title={`${t("appText.name")}:`}
            value={favoriteName}
            type="text"
            onChange={(e) => onChanged(e.target.value)}
            className="favorite-wrapper"
            hasError={hasError}
            errorMessage={errorMessage}
            onBlur={onBlur}
          />
        </div>
      )}
    </div>
  );
};

export default withTheme(Favorite);
